import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {NavigationError, Router} from '@angular/router';
import {OKTA_AUTH} from '@okta/okta-angular';
import {OktaAuth} from '@okta/okta-auth-js';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {ApplicationInsightsService} from '../../../core/app_insight/applicationinsights.service';

/**
 * Remplace OktaCallbackComponent : celui-ci n'affiche jamais son erreur sous un AppComponent OnPush
 * et reste blanc quand l'URL de callback ne contient plus code/state (rechargement pendant le callback).
 */
@Component({
    standalone: false,
    selector: 'app-login-callback',
    templateUrl: './login-callback.component.html',
    styleUrls: ['./login-callback.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginCallbackComponent implements OnInit, OnDestroy {
    error: string | null = null;
    private navigationErrorSubscription: Subscription;

    constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
                private router: Router,
                private changeDetectorRef: ChangeDetectorRef,
                private applicationInsightsService: ApplicationInsightsService) {
    }

    async ngOnInit(): Promise<void> {
        // La navigation vers l'URL d'origine (guards, lazy loading) peut échouer après un callback réussi
        this.navigationErrorSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationError))
            .subscribe((event: NavigationError) => this.showError(event.error));

        if (!this.oktaAuth.isLoginRedirect()) {
            // Callback déjà traité (rechargement de la page, ancien onglet) : rien à parser
            await this.router.navigateByUrl('/');
            return;
        }
        try {
            await this.oktaAuth.handleLoginRedirect();
        } catch (e) {
            this.showError(e);
        }
    }

    retry(): void {
        this.oktaAuth.signInWithRedirect().then();
    }

    private showError(error: any): void {
        console.error('[LoginCallback] Login redirect failed', error);
        this.applicationInsightsService.logException(error instanceof Error ? error : new Error(String(error)));
        this.error = error?.message ?? String(error);
        this.changeDetectorRef.markForCheck();
    }

    ngOnDestroy(): void {
        this.navigationErrorSubscription?.unsubscribe();
    }
}
